import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  providers: [],
  imports: [CommonModule, ReactiveFormsModule],
})
export class ApiModule {}
